import { FC, useEffect } from 'react';
import IOptionsListComponentOverride from './IOptionsListComponentOverride';
import styles from './OptionsListComponentOverride.module.scss';
import Scrollbar from '../../../scrollbar/Scrollbar';
import { ISelectGroupedOptions, ISelectOption } from '../../../../../utils/types';
import classNames from 'classnames';

const OptionsListComponentOverride: FC<IOptionsListComponentOverride> = ({
	selectId,
	selectedOption,
	options,
	onSelectChangeHandler,
}) => {
	const isGrouped = !!(options && options.length && 'groupName' in options[0]);

	useEffect(() => {
		const selected = document.getElementById(`${selectId}-${selectedOption}` || '');
		if (selected) selected.scrollIntoView({ block: 'nearest' });
	}, [selectId, selectedOption]);

	const renderGroupedItems = () => {
		const opts = options as ISelectGroupedOptions[];

		return opts.map((item: ISelectGroupedOptions) => (
			<div className={styles.group}>
				<div className={styles['group-title']}>{item.groupName}</div>

				<div className={styles.items}>
					{item.options.map((option: ISelectOption) => {
						return (
							<div
								id={`${selectId}-${option.value}`}
								key={option.value}
								className={classNames(
									styles.item,
									selectedOption === option.value ? styles.selected : '',
								)}
								onClick={() => onSelectChangeHandler(option)}
							>
								{option.label}
							</div>
						);
					})}
				</div>
			</div>
		));
	};

	const renderRegularItems = () => {
		const opts = options as ISelectOption[];

		if (opts.length) {
			return opts.map((option: ISelectOption) => (
				<div
					id={`${selectId}-${option.value}`}
					key={option.value}
					className={classNames(
						styles.item,
						selectedOption === option.value ? styles.selected : '',
					)}
					onClick={() => onSelectChangeHandler(option)}
				>
					{option.label}
				</div>
			));
		}

		return <div className={styles['no-options']}>No options to select</div>;
	};

	return (
		<Scrollbar small>
			<div className={classNames(styles['options-list'], isGrouped ? styles.grouped : '')}>
				{isGrouped ? renderGroupedItems() : renderRegularItems()}
			</div>
		</Scrollbar>
	);
};

export default OptionsListComponentOverride;
